export enum AgentBadgeType {
  HighlyRecommended = 'HighlyRecommended',
  TrustedAgent = 'TrustedAgent',
}
